import React, { useState } from 'react';

import { Modal, Text, Textarea, toastService } from '@thefarmersfront/kitchen';

import { ModalContentsContainer } from '~/components/common';

import { usePostRequestCancelMutation } from '~/hooks/receive';

type TypeReceiveRequestCancelModalProps = {
  ownerCode: string;
  requestCodes: string[];
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * [입고관리 > 입고요청관리] 요청 취소 모달
 */
const ReceiveRequestCancelModal = ({
  ownerCode,
  requestCodes,
  open,
  onCancel,
  onConfirm,
}: TypeReceiveRequestCancelModalProps) => {
  const cancelMutation = usePostRequestCancelMutation();

  const [reason, setReason] = useState('');

  const handleChangeReason = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
  };

  const handleConfirm = () => {
    cancelMutation.mutate(
      { ownerCode, params: { orderCodes: requestCodes, reason } },
      {
        onSuccess: () => {
          toastService.addToast({ message: '요청 취소되었습니다.' });
          onConfirm();
        },
      }
    );
  };

  return (
    <Modal
      title="요청 취소"
      open={open}
      confirmText="요청 취소"
      disabled={reason.length === 0}
      onCancel={onCancel}
      onConfirm={handleConfirm}
    >
      <ModalContentsContainer gap={8}>
        <Text size="large" element="span">
          선택한{' '}
          <Text size="large" weight="semi-bold" element="span">
            {requestCodes.length}건
          </Text>
          의 입고 요청의 취소 사유를 입력해 주세요.
        </Text>
        <Textarea
          size="small"
          height="116px"
          placeholder="취소 사유 입력"
          count
          maxLength={100}
          value={reason}
          onChange={handleChangeReason}
        />
      </ModalContentsContainer>
    </Modal>
  );
};

export default ReceiveRequestCancelModal;
